<template>
  <div>
    <el-card
      class="left-box"
      body-style="height:calc(100vh - 150px);overflow-y:auto;padding:0px 20px;padding-bottom: 0px"
      v-loading="loading"
    >
      <div
        style="
          height: 30px;
          margin-bottom: 10px;
          margin-top: 10px;
          width: 100%;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          position: relative;
          justify-content: space-between;
        "
      >
        <div>
          <!-- <el-input
            style="width: 300px"
            clearable
            v-model="searchData.Device"
            placeholder="请输入设备名称/编号"
          ></el-input> -->
          <!-- <el-input
          style="width: 300px; margin-left: 10px"
          v-model="searchData.InforType"
          clearable
          placeholder="请输入文件类型"
        ></el-input> -->
          <el-select
            v-model="searchData.DocType"
            filterable
            clearable
            placeholder="请选择文件类型"
            style="width: 300px; margin-left: 10px"
          >
            <el-option
              v-for="item in DeviceTypeList"
              :key="item.Id"
              :label="item.DicName"
              :value="item.DicName"
            ></el-option>
          </el-select>
          <el-input
            style="width: 300px; margin-left: 10px"
            v-model="searchData.DocName"
            clearable
            placeholder="请输入文件名称"
          ></el-input>
          <el-button type="primary" style="margin-left: 10px" @click="Search"
            >查询</el-button
          >
        </div>
        <div style="">
          <span class="Quantity">文件数量小计：{{ TotalQuantity }}</span>
          <span class="Quantity">文件数量总计：{{ SumQuantity }}</span>
        </div>
      </div>
      <div style="width: 100%">
        <el-table height="calc(100vh - 240px)" :data="dataList">
          <el-table-column
            type="index"
            label="序号"
            width="55"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="SupplierName"
            label="供应商名称"
            width="360px"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="TypeName"
            label="文件类型"
            width="200px"
            align="center"
          ></el-table-column>
          <el-table-column prop="NewFileName" label="文件名称" align="center">
            <template slot-scope="scope">
              <a :href="scope.row.Url" target="_blank" style="color: #409eff">{{
                scope.row.NewFileName
              }}</a>
            </template>
          </el-table-column>
          <el-table-column prop="CreateTime" label="上传日期" width="160px">
            <template slot-scope="scope">
              {{ moment(scope.row.CreateTime).format('YYYY-MM-DD hh:mm:ss') }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div
        style="
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: right;
        "
      >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.PageIndex"
          :page-sizes="pagination.PageSizes"
          :page-size="pagination.PageRows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  data() {
    return {
      moment,
      dataStatistics: {},
      dataList: [],
      searchData: {
        DocType: '',
        DocName: '',
      },
      DeviceTypeList: [],
      loading: false,
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
      backName: '',
      pId: '',
      SupplierId: '',
      devId: '',
      SumQuantity: '',
      TotalQuantity: '',
    }
  },
  props: {},
  components: {},
  methods: {
    getDeviceTypeList() {
      this.$http
        .post('/Base_ProjectManage/Project_DictionaryMain/GetTheDataByDicKey', {
          Condition: 'DicKey',
          Keyword: 'SupplierType',
        })
        .then((res) => {
          if (res.Success) {
            this.DeviceTypeList = res.Data.DictionaryDetailsList || []
          }
        })
    },
    handleBack() {
      this.$emit('toDom', 'ProjectAll')
    },
    handleClick(row) {
      window.open(row.InforUrl)
    },
    Search() {
      this.pagination.PageIndex = 1
      this.getDataList()
    },
    getDataList() {
      this.loading = true
      this.$http
        .post(`/Base_ProjectWork/Base_Project/GetSupplierDocument`, {
          PageIndex: this.pagination.PageIndex,
          PageRows: this.pagination.PageRows,
          Search: {
            projectId: this.pId,
            supplierId: this.SupplierId,

            ...this.searchData,
          },
        })
        .then((res) => {
          this.loading = false
          if (res.Success) {
            this.dataList = res.Data
            this.TotalQuantity = res.TotalQuantity || 0
            this.SumQuantity = res.SumQuantity || 0
            this.pagination.total = res.Total
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getDataList()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getDataList()
    },
  },
  mounted() {},
  created() {
    this.pId = this.$route.query.id
    this.backName = window.localStorage.getItem('ProjectName') || ''
    this.devId = this.$route.query.devId
    this.SupplierId = this.$route.query.ParentId
    this.getDeviceTypeList()
    this.getDataList()
  },
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
::v-deep .left-box {
  .el-card__header {
    padding: 10px;
    border: none;
  }
}
::v-deep .con .number {
  color: #e6a23c;
}
.head {
  height: 70px;
  // border-bottom: 1px solid #ccc;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
::v-deep .el-pagination__total {
  font-weight: bold;
  font-size: 18px !important;
}
.Quantity {
  font-weight: bold;
  font-size: 18px;
  margin-right: 20px;
  color: #606266;
}
</style>
